import { useEffect } from "react";
import { Link } from "react-router-dom";
import { MonitorSmartphone, Users, Tablet, Scale, ArrowRight } from "lucide-react";
import { OFFRES_LIST } from "../offres";
import { fmt, ttc } from "../components/offres/OffrePage";
import { GuideChoixOffre } from "../components/offres/GuideChoixOffre";
import { GalerieVideos, PresentationVideo } from "../components/offres/GalerieVideos";

export default function HubOffres() {
  useEffect(() => {
    if (window.location.hash === "#guide") setTimeout(() => document.getElementById("guide")?.scrollIntoView({ behavior: "smooth" }), 150);
  }, []);
  return (
    <div data-testid="hub-offres-page">
      <section className="bg-[#E0F2FE]">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <p className="font-mono text-xs uppercase tracking-widest text-[#0369A1]">Solutions Vitalis</p>
          <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-[#0C4A6E] sm:text-5xl">Nos offres clés en main</h1>
          <p className="mt-4 max-w-2xl text-base text-slate-700 md:text-lg">Du cabinet solo au CHU : {OFFRES_LIST.length} formules tout compris — licences, tablette de qualité, support technique et hébergement cloud sécurisé. Abonnement mensuel, TVA 18 % en sus.</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href="#guide" data-testid="hub-guide-link" className="inline-flex items-center gap-2 rounded-full bg-[#0369A1] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#075985]">Trouver mon offre en 3 clics</a>
            <Link to="/solutions/comparatif" data-testid="hub-comparatif-link" className="inline-flex items-center gap-2 rounded-full border border-[#7DC4E8] bg-white px-5 py-2.5 text-sm font-semibold text-[#0369A1] transition-colors hover:bg-[#F8FBFE]"><Scale size={15} /> Comparer toutes les solutions</Link>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 pt-10 sm:px-6"><GuideChoixOffre /></section>
      <PresentationVideo />

      <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
        <h2 className="mb-6 font-display text-base font-bold uppercase tracking-wider text-[#0369A1] md:text-lg">Toutes nos offres</h2>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="hub-offres-grid">
          {OFFRES_LIST.map((o) => (
            <article key={o.slug} className="group flex flex-col overflow-hidden rounded-2xl border border-[#7DC4E8] bg-white shadow-sm transition-transform duration-200 hover:-translate-y-0.5" data-testid={`hub-offre-${o.slug}`}>
              <Link to={`/offres/${o.slug}`} className="relative block aspect-[16/9] overflow-hidden bg-[#E0F2FE]">
                <img src={o.image} alt={`Vitalis ${o.nom}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute right-3 top-3 rounded-full bg-[#0369A1] px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-white">Niveau {o.niveau}</span>
              </Link>
              <div className="flex flex-1 flex-col p-5">
                <p className="text-[11px] font-semibold uppercase tracking-wider text-[#0369A1]">{o.cible}</p>
                <h2 className="mt-1 font-display text-lg font-bold text-navy"><Link to={`/offres/${o.slug}`}>Vitalis {o.nom}</Link></h2>
                <div className="mt-3 flex flex-wrap gap-1">
                  {o.modules.map((m) => <span key={m.title} className="rounded-md border border-[#7DC4E8] bg-[#E0F2FE] px-1.5 py-0.5 text-[11px] text-[#0C4A6E]">{m.title}</span>)}
                </div>
                <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-600">
                  <span className="inline-flex items-center gap-1"><Users size={13} className="text-[#0369A1]" /> {o.licences} licences</span>
                  <span className="inline-flex items-center gap-1"><Tablet size={13} className="text-[#0369A1]" /> Tablette + support inclus</span>
                </div>
                <div className="mt-auto pt-5">
                  <p className="font-display text-2xl font-bold text-[#0369A1]" data-testid={`hub-price-${o.slug}`}>{fmt(o.prixHt)} <span className="text-sm font-semibold">FCFA HT / mois</span></p>
                  <p className="text-xs text-slate-500">soit {fmt(ttc(o.prixHt, o.tva))} FCFA TTC / mois</p>
                  <div className="mt-4 flex items-center gap-2">
                    <Link to={`/offres/${o.slug}#demo`} data-testid={`hub-demo-${o.slug}`} className="inline-flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-[#0369A1] px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-[#075985]"><MonitorSmartphone size={14} /> Demander une démo</Link>
                    <Link to={`/offres/${o.slug}`} data-testid={`hub-voir-${o.slug}`} className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-[#7DC4E8] bg-white px-4 py-2 text-xs font-semibold text-[#0369A1] transition-colors hover:bg-[#E0F2FE]">Voir <ArrowRight size={13} /></Link>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
      <GalerieVideos />
    </div>
  );
}
